export default __webpack_public_path__ + "static/media/nodata.b76f9caa.svg";